import(/* webpackMode: "eager", webpackExports: ["App"] */ "__barrel_optimize__?names=App!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "__barrel_optimize__?names=ConfigProvider!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/TopNav/TopNavOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryProvider"] */ "/app/src/context/CategoriesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/context/channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalCustomerProvider"] */ "/app/src/context/CustomerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalInquiryProvider"] */ "/app/src/context/ModalInquiryContext.tsx");
